import {
    ANALYZE_INDUSTRY_BENCHMARK,
    ANALYZE_MENTIONS,
    ANALYZE_REELS,
    CAPTIONS_LISTS,
    CONTENT_ALBUMS,
    CONTENT_POSTS,
    DASHBOARD,
    DASHBOARD_CUSTOMIZATION,
    LISTENING_COMPETITORS,
    LISTENING_HASHTAGS,
    MANAGE_COMMENTS_TRACKER,
    MANAGE_DM_TRACKER,
    MANAGE_MENTIONS_TRACKER,
    MEDIA_LIBRARY,
    REPORTS,
    REPORTS_ACCOUNTS,
    REPORTS_COMPETITORS,
    REPORTS_HASHTAGS,
    SCHEDULER
} from '@/lib/routes/privateRoutes';

// TODO: Map missing feature routes when applicable
export const FEATURES = {
    ANALYTICS: {
        DASHBOARD: DASHBOARD,
        SOCIAL_PROFILE: 'feature.analytics.social_profile',
        GROUP: 'feature.analytics.group',
        REELS: ANALYZE_REELS,
        POSTS: 'feature.analytics.promoted_posts',
        TAGS_AND_MENTIONS: ANALYZE_MENTIONS
    },
    REPORTING: {
        ACCOUNT_ANALYTICS: REPORTS_ACCOUNTS,
        COMPETITORS: REPORTS_COMPETITORS,
        HASHTAGS: REPORTS_HASHTAGS,
        DASHBOARD: REPORTS,
        DASHBOARD_CUSTOMIZATION: DASHBOARD_CUSTOMIZATION,
        COMPANY_BRANDED_PDF: 'feature.reporting.company_branded_pdf'
    },
    CONTENT: {
        POSTS: CONTENT_POSTS,
        ALBUMS: CONTENT_ALBUMS,
        CAMPAIGN_TRACKING: 'feature.content.campaign_tracking',
        LABELS: 'feature.content.labels'
    },
    PUBLISHING: {
        POST_SCHEDULING: SCHEDULER,
        STORY_SCHEDULING: 'feature.publishing.story_scheduling',
        REELS_SCHEDULING: 'feature.publishing.reels_scheduling',
        CROSS_POSTING: 'feature.publishing.cross_posting',
        FIRST_COMMENT_SCHEDULING: 'feature.publishing.first_comment_scheduling',
        MEDIA_LIBRARY: MEDIA_LIBRARY,
        // Or Hashtag lists
        SAVED_CAPTIONS: CAPTIONS_LISTS,
        POST_APPROVAL_AND_COLLABORATION: 'feature.publishing.post_approval_and_collaboration'
    },
    CONVERSATIONS: {
        COMMENT_TRACKING: MANAGE_COMMENTS_TRACKER,
        MENTIONS_TRACKING: MANAGE_MENTIONS_TRACKER,
        DM_MANAGEMENT: MANAGE_DM_TRACKER
    },
    LISTING: {
        COMPETITORS: LISTENING_COMPETITORS,
        HASHTAGS: LISTENING_HASHTAGS,
        CUSTOMIZED_FEEDS: 'feature.listing.customized_feeds',
        INDUSTRY_BENCHMARK: ANALYZE_INDUSTRY_BENCHMARK
    },
    TOOLS_AND_SERVICES: {
        MOBILE_APP: 'feature.tools_and_services.mobile_app'
    }
} as const;
